import { styled } from '@attentive-platform/stem-ui';

export const CardWrap = styled('div')(() => ({
  background: '#fff',
  border: '1px solid #e2e8f0',
  borderRadius: '0.5rem',
  padding: '1.5rem',
  width: '860px',
  maxWidth: '100%',
}));

export const LookupRow = styled('div')(() => ({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'flex-end',
  marginBottom: '1.25rem',
  flexDirection: 'column',
}));

export const CompanyBadge = styled('div')(() => ({
  background: '#ebf4ff',
  border: '1px solid #bee3f8',
  padding: '0.4rem 0.75rem',
  borderRadius: '0.25rem',
  marginBottom: '1.25rem',
  fontSize: '0.875rem',
  color: '#2a4365',
}));

export const TilesGrid = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '0.625rem',
  marginBottom: '1rem',
}));

export const TileBox = styled('div')(({ variant }) => ({
  border: `1px solid ${variant === 'good' ? '#c6f6d5' : variant === 'warn' ? '#f6e05e' : '#e2e8f0'}`,
  borderRadius: '6px',
  padding: '0.625rem 0.75rem',
  background: variant === 'good' ? '#f0fff4' : variant === 'warn' ? '#fffff0' : '#fafbfc',
}));

export const TileLabel = styled('div')(() => ({
  fontSize: '11px',
  color: '#718096',
  marginBottom: '2px',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
}));

export const TileValue = styled('div')(() => ({
  fontSize: '0.9375rem',
  fontWeight: 600,
  color: '#1a202c',
  lineHeight: 1.3,
}));

export const TileSub = styled('div')(() => ({
  fontSize: '11.5px',
  color: '#718096',
  marginTop: '2px',
}));

export const SectionBlock = styled('div')(() => ({
  marginBottom: '1rem',
}));

export const SectionTitle = styled('div')(() => ({
  fontSize: '0.9375rem',
  fontWeight: 600,
  color: '#2d3748',
  marginBottom: '0.75rem',
  paddingBottom: '0.5rem',
  borderBottom: '1px solid #e2e8f0',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  flexWrap: 'wrap',
}));

export const InlineBadge = styled('span')(({ variant }) => {
  const colors = {
    new: { bg: '#ebf8ff', border: '#bee3f8', color: '#2b6cb0' },
    existing: { bg: '#f7fafc', border: '#e2e8f0', color: '#718096' },
    changed: { bg: '#fffaf0', border: '#fbd38d', color: '#c05621' },
    editable: { bg: '#f0fff4', border: '#c6f6d5', color: '#276749' },
  };
  const c = colors[variant] || colors.existing;
  return {
    display: 'inline-block',
    fontSize: '11px',
    fontWeight: 500,
    padding: '1px 6px',
    borderRadius: '3px',
    background: c.bg,
    border: `1px solid ${c.border}`,
    color: c.color,
  };
});

export const BannerBox = styled('div')(({ variant }) => {
  const variants = {
    info: { bg: '#ebf8ff', border: '#bee3f8' },
    warn: { bg: '#fffff0', border: '#f6e05e' },
    error: { bg: '#fff5f5', border: '#fc8181' },
  };
  const v = variants[variant] || variants.info;
  return {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'flex-start',
    background: v.bg,
    border: `1px solid ${v.border}`,
    borderRadius: '4px',
    padding: '0.625rem 0.75rem',
    marginBottom: '0.75rem',
    fontSize: '12.5px',
    color: '#1a202c',
  };
});

export const BannerIcon = styled('span')(() => ({
  flexShrink: 0,
  fontWeight: 700,
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '11px',
  background: 'rgba(0,0,0,0.08)',
  marginTop: '1px',
}));

export const FormDivider = styled('hr')(() => ({
  border: 'none',
  borderTop: '1px solid #e2e8f0',
  margin: '1.25rem 0',
}));

export const FieldWrap = styled('div')(() => ({
  marginBottom: '0.75rem',
}));

export const FieldLabel = styled('label')(() => ({
  display: 'block',
  fontSize: '13px',
  fontWeight: 500,
  color: '#4a5568',
  marginBottom: '4px',
}));

export const HelpNote = styled('div')(() => ({
  fontSize: '12px',
  color: '#718096',
  marginTop: '4px',
}));

export const ToggleRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.75rem',
  marginBottom: '1rem',
}));

export const ToggleTrack = styled('label')(() => ({
  position: 'relative',
  display: 'inline-block',
  width: '40px',
  height: '24px',
  flexShrink: 0,
  marginTop: '2px',
  cursor: 'pointer',
  '& input': {
    opacity: 0,
    width: 0,
    height: 0,
    position: 'absolute',
  },
  '& span': {
    position: 'absolute',
    inset: 0,
    backgroundColor: '#cbd5e0',
    borderRadius: '9999px',
    transition: 'background-color 0.2s',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '20px',
      height: '20px',
      left: '2px',
      top: '2px',
      backgroundColor: '#fff',
      borderRadius: '50%',
      transition: 'transform 0.2s',
    },
  },
  '& input:checked + span': { backgroundColor: '#4299e1' },
  '& input:checked + span::before': { transform: 'translateX(16px)' },
}));

export const ToggleText = styled('div')(() => ({ textAlign: 'left' }));

export const TradesRow = styled('div')(() => ({
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
}));

export const TradeChip = styled('button')(({ selected }) => ({
  padding: '0.25rem 0.625rem',
  borderRadius: '9999px',
  fontSize: '0.8125rem',
  fontWeight: 500,
  border: `1px solid ${selected ? '#4299e1' : '#cbd5e0'}`,
  background: selected ? '#4299e1' : '#fff',
  color: selected ? '#fff' : '#4a5568',
  cursor: 'pointer',
  transition: 'all 0.15s',
  '&:hover': { borderColor: '#4299e1' },
}));

export const SaveRow = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '1.25rem',
  borderTop: '1px solid #e2e8f0',
  marginTop: '1.25rem',
}));

export const TierTableWrap = styled('div')(() => ({
  marginTop: '0.75rem',
  '& table': {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
  },
  '& th': {
    background: '#f7fafc',
    padding: '6px 8px',
    textAlign: 'left',
    fontWeight: 500,
    color: '#4a5568',
    border: '1px solid #e2e8f0',
  },
  '& td': {
    padding: '4px 6px',
    border: '1px solid #e2e8f0',
    verticalAlign: 'middle',
  },
  '& input[type=number]': {
    width: '100%',
    padding: '4px 6px',
    border: '1px solid #e2e8f0',
    borderRadius: '4px',
    fontSize: '13px',
  },
}));

export const SwitchConfirmBox = styled('div')(() => ({
  border: '1px solid #fed7d7',
  borderRadius: '6px',
  padding: '1rem',
  marginTop: '0.75rem',
  background: '#fff5f5',
}));

export const CheckboxRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginBottom: '0.375rem',
  '& input[type=checkbox]': {
    width: '14px',
    height: '14px',
    cursor: 'pointer',
  },
  '& label': {
    fontSize: '13px',
    color: '#4a5568',
    marginBottom: 0,
    cursor: 'pointer',
  },
}));

export const CondBlock = styled('div')(() => ({
  border: '1px dashed #bee3f8',
  borderRadius: '4px',
  padding: '0.75rem',
  marginTop: '0.75rem',
  background: '#f7fbff',
}));

export const ReadOnlyNote = styled('p')(() => ({
  fontSize: '11.5px',
  color: '#718096',
  marginTop: '8px',
  marginBottom: 0,
}));

export const TwoColRow = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '0.75rem',
}));
